<script setup lang="ts">
import { SIDEBAR_IDS } from '@design-system/data/sidebarIds'

const { isDialogOpen } = useDialog(SIDEBAR_IDS.pdpInfoPaymentsItem)

const { data: infoPaymentsContent, execute } =
  await useInfosWithTitleItem('info-payments')
watch(isDialogOpen, async value => {
  if (value) {
    await execute()
  }
})

const { isEmporioArmaniWebsite, isEa7Website } = useWebsite()

defineProps<{
  price?: number
  priceCents?: number
}>()
</script>
<template>
  <OrganismsSidebarSlide
    :id="SIDEBAR_IDS.pdpInfoPaymentsItem"
    :header-props="{ titleText: infoPaymentsContent?.content?.title ?? '' }"
  >
    <template #body>
      <div class="flex flex-col gap-y-2">
        <UtilsMarkdown
          v-if="infoPaymentsContent?.content?.body"
          :content="infoPaymentsContent?.content?.body"
          class="text-light-6 mb-2"
          container="h3"
        />

        <div :class="{ invert: isEmporioArmaniWebsite || isEa7Website }">
          <ClientOnly>
            <PaypalWrapper v-if="price" :amount="price" />
          </ClientOnly>
          <KlarnaPlacementWrapper
            v-if="priceCents"
            :placement="{
              key: 'credit-promotion-auto-size',
              purchaseAmount: priceCents,
            }"
          />
        </div>
      </div>
    </template>
  </OrganismsSidebarSlide>
</template>
